var styles = {"box":"CryptoValue_box_f8aft_1","crypto":"CryptoValue_crypto_f8aft_16","value":"CryptoValue_value_f8aft_20","currency":"CryptoValue_currency_f8aft_23","v2":"CryptoValue_v2_f8aft_26","v3":"CryptoValue_v3_f8aft_35"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
